import React, {forwardRef, useImperativeHandle, useState, useRef} from 'react';
import {Modal, Form, Input, Select, Upload, notification, message, Typography, Divider} from 'antd';
import {LoadingOutlined, PlusOutlined} from '@/icons';
import {getMediaId, getWelcomeMediaId} from '@/api/customer';
import {API_ROOT} from '@/env';
import {getTokens} from '@/util/AuthStore';
import PreviewModal from '@/page/component/UploadWallModal/PreviewModal';

const LinkFormModal = forwardRef(({createLink, url = '/moment'}, ref) => {
    const UPLOAD_URL = `${API_ROOT}/attach` + url;
    const [httpHead, setHttpHead] = useState('https://');
    const [picHttpHead, setPicHttpHead] = useState('https://');
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mediaId, setMediaId] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);
    const [attachId, setAttachId] = useState(null);
    const [msgType, setMsgType] = useState(null);
    const [needDesc, setNeedDesc] = useState(false);
    const previewModalRef = useRef();
    const [form] = Form.useForm();
    const addonBefore = (
        <Select value={httpHead} className="select-before" onChange={e => setHttpHead(e)}>
            <Select.Option value="http://">http://</Select.Option>
            <Select.Option value="https://">https://</Select.Option>
        </Select>
    );
    const addonPicBefore = (
        <Select value={picHttpHead} className="select-before" onChange={e => setPicHttpHead(e)}>
            <Select.Option value="http://">http://</Select.Option>
            <Select.Option value="https://">https://</Select.Option>
        </Select>
    );

    useImperativeHandle(ref, () => ({
        open,
    }));

    function renderDescription(errcode) {
        return (
            <>
                <p>{'错误码：' + errcode}</p>
                <a
                    href={'https://open.work.weixin.qq.com/devtool/query?e=' + errcode}
                    target="_blank"
                >
                    点击查询具体错误
                </a>
            </>
        );
    }

    function open(msgType, needDesc = false) {
        setMsgType(msgType);
        setNeedDesc(needDesc);
        setVisible(true);
    }

    function onPreview(file) {
        if (file.response) {
            previewModalRef.current.showModal(file.response.data[0].urls.file);
        } else message.error('无法预览,请删除该图片');
    }

    function close() {
        setVisible(false);
    }

    function beforeUpload(file) {
        return checkWH(file, 1440, 1080);
        //
        // // Upload.LIST_IGNORE 算是 antd 对于 beforeUpload 的 hack
        // // 如果返回 false 的话，该文件缩略图仍然会显示在预览列表中，
        // // 所以开发方新增了这个特定的属性用于处理这个问题
        // return Upload.LIST_IGNORE;
    }

    function checkWH(file, width, height) {
        return new Promise(function (resolve, reject) {
            let filereader = new FileReader();
            filereader.onload = e => {
                let src = e.target.result;
                const image = new Image();
                image.onload = () => {
                    if ((width && image.width > width) || (height && image.height > height)) {
                        message.warn(`图片宽高必须小于 ${width} * ${height}, 请删除并重新上传`);
                        reject();
                    } else {
                        resolve();
                    }
                };
                image.onerror = reject;
                image.src = src;
            };
            filereader.readAsDataURL(file);
        });
    }

    function onUploadChange({file}) {
        if (file.status === 'uploading') setLoading(true);
        if (file.status === 'done') {
            const {
                response: {data},
            } = file;
            console.log('....', data);
            let finalData;
            if (needDesc) {
                finalData = data;
                setAttachId(finalData.id);
                setLoading(false);
                // getWelcomeMediaId(finalData).then(res => {
                //     setLoading(false);
                //     const {
                //         data: {media_id, errcode},
                //     } = res;
                //     if (errcode === 0) setMediaId(media_id); else {
                //         setMediaId(null);
                //         notification.error({
                //             message: '上传失败', description: renderDescription(errcode),
                //         });
                //     }
                // });
            } else {
                finalData = data[0];
                getMediaId(finalData).then(res => {
                    setLoading(false);
                    const {
                        data: {media_id, errcode},
                    } = res;
                    if (errcode === 0) setMediaId(media_id);
                    else {
                        setMediaId(null);
                        notification.error({
                            message: '上传失败',
                            description: renderDescription(errcode),
                        });
                    }
                });
            }
            setImageUrl(finalData.urls.file);
        }
    }

    function renderWebApp() {
        return (
            <div>
                <Form.Item
                    label="标题"
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: '标题不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="小程序appid"
                    name="appid"
                    rules={[
                        {
                            required: true,
                            message: '小程序appid不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="小程序page路径"
                    name="page"
                    rules={[
                        {
                            required: true,
                            message: '小程序page路径不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <div>
                    <Typography.Text type="secondary">
                        {`文件个数不超过1个, 图片大小不超过 1440 * 1080`}
                    </Typography.Text>
                    <Divider />
                </div>
                <Form.Item label="封面图">
                    <Upload
                        onPreview={onPreview}
                        maxCount={1}
                        listType="picture-card"
                        action={UPLOAD_URL}
                        data={{category: 'welcome'}}
                        headers={{
                            Authorization: `Bearer ${getTokens().access_token}`, // 获取 token 放在这儿可以在执行的时候再读取
                        }}
                        beforeUpload={beforeUpload}
                        onChange={onUploadChange}
                    >
                        <div>
                            {loading ? <LoadingOutlined /> : <PlusOutlined />}
                            <div style={{marginTop: 8}}>上传封面图</div>
                        </div>
                    </Upload>
                </Form.Item>
            </div>
        );
    }

    function renderLink() {
        return (
            <div>
                <Form.Item
                    label="标题"
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: '标题不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="链接"
                    name="url"
                    rules={[
                        {
                            required: true,
                            message: '链接不能为空!',
                        },
                    ]}
                >
                    <Input addonBefore={addonBefore} />
                </Form.Item>
                <div>
                    <Typography.Text type="secondary">
                        {`文件个数不超过1个, 图片大小不超过 1440 * 1080`}
                    </Typography.Text>
                    <Divider />
                </div>
                <Form.Item label="封面图">
                    <Upload
                        onPreview={onPreview}
                        maxCount={1}
                        listType="picture-card"
                        action={UPLOAD_URL}
                        headers={{
                            Authorization: `Bearer ${getTokens().access_token}`, // 获取 token 放在这儿可以在执行的时候再读取
                        }}
                        beforeUpload={beforeUpload}
                        onChange={onUploadChange}
                    >
                        <div>
                            {loading ? <LoadingOutlined /> : <PlusOutlined />}
                            <div style={{marginTop: 8}}>上传封面图</div>
                        </div>
                    </Upload>
                </Form.Item>
            </div>
        );
    }

    function renderLinkWithDesc() {
        return (
            <div>
                <Form.Item
                    label="标题"
                    name="title"
                    rules={[
                        {
                            required: true,
                            message: '标题不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="描述" name="desc">
                    <Input />
                </Form.Item>
                <Form.Item label="图片连接" name="picurl">
                    <Input addonBefore={addonPicBefore} />
                </Form.Item>
                <Form.Item
                    label="链接"
                    name="url"
                    rules={[
                        {
                            required: true,
                            message: '链接不能为空!',
                        },
                    ]}
                >
                    <Input addonBefore={addonBefore} />
                </Form.Item>
            </div>
        );
    }

    function formSubmit() {
        form.validateFields()
            .then(values => {
                form.resetFields();
                if (msgType === 'LINK' && needDesc) {
                    values.url = httpHead + values.url;
                    values.picurl = picHttpHead + values.picurl;
                }
                if (msgType === 'LINK' && !needDesc) {
                    values.url = httpHead + values.url;
                    values.media_id = mediaId;
                    values.imageUrl = imageUrl;
                }
                if (msgType === 'WEBAPP') {
                    values.pic_media_id = attachId;
                    values.imageUrl = imageUrl;
                }
                createLink(values);
                close();
            })
            .catch(info => {
                console.log('Validate Failed:', info);
            });
    }

    return (
        <Modal
            // title="新增链接"
            okText="确定"
            cancelText="取消"
            visible={visible}
            onCancel={close}
            onOk={formSubmit}
        >
            <Form form={form}>
                {msgType === 'LINK' && needDesc && renderLinkWithDesc()}
                {msgType === 'LINK' && !needDesc && renderLink()}
                {msgType === 'WEBAPP' && renderWebApp()}
            </Form>
            <PreviewModal ref={previewModalRef} />
        </Modal>
    );
});

export default LinkFormModal;
